import { MenuItem } from 'vue-graphql-models';

export default [

  new MenuItem({
    id: 'createNewChemical',
    title: 'Create New Chemical',
    subtitle: 'Add New Chemical',
    route: { name: 'createNewChemical' },
    customIcon: true,
    icon: 'dhc-new',
  }),
  new MenuItem({
    id: 'chemicalHelp',
    title: 'Help',
    subtitle: 'How to\'s and Contact Info',
    customIcon: true,
    icon: 'dhc-help',
  }),
  new MenuItem({
    id: 'chemicalEdit',
    title: 'Edit Chemical',
    subtitle: 'Edit Chemical Details',
    route: { name: 'chemicalEdit' },
    customIcon: true,
    icon: 'dhc-pencil-s',
  }),
  new MenuItem({
    id: 'chemicalDelete',
    title: 'Delete Chemical',
    subtitle: 'Remove Chemical Record',
    route: { name: 'contactForm' },
    customIcon: true,
    icon: 'dhc-trash',
  }),
  new MenuItem({
    id: 'chemicalClone',
    title: 'Clone Chemical',
    subtitle: 'Clone Chemical Details',
    route: { name: 'chemicals' },
    customIcon: true,
    icon: 'dhc-new',
  }),
  new MenuItem({
    id: 'chemicalAddNotes',
    title: 'Add Notes',
    subtitle: 'Add new notes',
    route: { name: 'chemicals' },
    customIcon: true,
    icon: 'dhc-file-text',
  }),
];
